import React, { useContext } from 'react';
import styles from './Principal.module.css';
import Header from '../Header';
import NavPrincipal from './NavPrincipal';
import { Route, Routes, useLocation } from 'react-router-dom';
import Central from '../Content/Central';
import SelectClinica from '../Form/SelectClinica';
import PasswordChange from '../Content/PasswordChange';
import UserContext from '../../UserContext';
import clinicas from './Clinicas';
import NotFound from '../Login/NotFound';

const Principal = () => {
  const location = useLocation();
  const { clinica } = React.useContext(UserContext);

  React.useEffect(() => {
    // console.log(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <section className={styles.principal}>
        <div className={styles.menus}>
          <NavPrincipal />
          <div className={styles.exibicao}>
            <Header />
            {location.pathname !== '/home/alterarsenha' && <SelectClinica />}
            <Routes>
              <Route path="*" element={<NotFound />} />
              <Route
                path="/"
                element={<Central tipo={1} titulo="Últimos documentos" />}
              />
              <Route
                path="resultados"
                element={<Central tipo={5} titulo="Resultados" />}
              />
              {/* <h1 className={`${styles.frase} animeLeft2`}>
            Nenhum documento encontrado{' '}
            {clinica ? 'para a clínica ' + clinica.nome : ''}
              </h1> */}
              <Route
                path="pedidosdeexames"
                element={<Central tipo={1} titulo="Pedidos de Exame" />}
              />
              <Route
                path="receitas"
                element={<Central tipo={2} titulo="Receitas" />}
              />
              <Route
                path="relatorios"
                element={<Central tipo={3} titulo="Relatórios Médicos" />}
              />
              <Route
                path="atestados"
                element={<Central tipo={4} titulo="Atestados" />}
              />
              <Route
                path="prontuarios"
                element={<Central tipo={6} titulo="Prontuários" />}
              />
              {/* <Route path="alterarsenha" element={<PasswordChange />} /> */}
            </Routes>
          </div>
        </div>
      </section>
    </>
  );
};

export default Principal;
